import { atom } from "jotai";

import { requestGroupControlsAtom } from "../../selectors/requestGroupControlsAtom/requestGroupControlsAtom";
import {
  currentBookingAtom,
  currentModalStepAtom,
  pendingRequestGroupAtom,
} from "../../stores";

export const beginRequestGroupAtom = atom(null, (get, set) => {
  const booking = get(currentBookingAtom);
  const { canAdd, groupCount } = get(requestGroupControlsAtom);
  if (!booking || !canAdd) return;

  set(pendingRequestGroupAtom, { booking, bookingIndex: groupCount });
  set(currentBookingAtom, {
    ...booking,
    requestGroupCount: groupCount + 1,
    rounds: booking.rounds.map((round) => ({
      ...round,
      bookingIndex: round.bookingIndex ?? 0,
    })),
  });
  set(currentModalStepAtom, {
    type: booking.isPrivate ? "AddPlayerPrivate" : "AddPlayer",
    bookingIndex: groupCount,
  });
});

export const finishRequestGroupAtom = atom(null, (get, set) => {
  const pending = get(pendingRequestGroupAtom);
  const booking = get(currentBookingAtom);
  if (
    !pending ||
    !booking?.rounds.some(
      (round) => round.bookingIndex === pending.bookingIndex && round.player.id
    )
  )
    return;

  set(pendingRequestGroupAtom, null);
  set(currentModalStepAtom, {
    type: booking.isPrivate ? "EditRoundsPrivate" : "EditRounds",
  });
});

export const cancelRequestGroupAtom = atom(null, (get, set) => {
  const pending = get(pendingRequestGroupAtom);
  if (!pending) return;

  set(currentBookingAtom, pending.booking);
  set(pendingRequestGroupAtom, null);
  set(currentModalStepAtom, {
    type: pending.booking.isPrivate ? "EditRoundsPrivate" : "EditRounds",
  });
});

export const removeRequestGroupAtom = atom(
  null,
  (get, set, bookingIndex: number) => {
    const booking = get(currentBookingAtom);
    const { canRemove, groupCount } = get(requestGroupControlsAtom);
    if (
      !booking ||
      !canRemove ||
      !Number.isInteger(bookingIndex) ||
      bookingIndex < 0 ||
      bookingIndex >= groupCount
    )
      return;

    set(currentBookingAtom, {
      ...booking,
      requestGroupCount: groupCount - 1,
      rounds: booking.rounds
        .filter((round) => (round.bookingIndex ?? 0) !== bookingIndex)
        .map((round) => ({
          ...round,
          bookingIndex:
            (round.bookingIndex ?? 0) > bookingIndex
              ? (round.bookingIndex ?? 0) - 1
              : round.bookingIndex ?? 0,
        })),
    });
  }
);
